module.exports = __webpack_public_path__ + "img/dwb3.1a9302df.jpg";